// https://github.com/blockchain/service-nabu-core/wiki/Charge-Payment-Type
export enum PaymentState {
  AUTHORIZED = 'AUTHORIZED',
  CLEARED = 'CLEARED',
  COMPLETE = 'COMPLETE',
  CREATED = 'CREATED',
  CREDITED = 'CREDITED',
  FAILED = 'FAILED',
  FRAUD_REVIEW = 'FRAUD_REVIEW',
  MANUAL_REVIEW = 'MANUAL_REVIEW',
  PENDING = 'PENDING',
  PRE_CHARGE_APPROVED = 'PRE_CHARGE_APPROVED',
  PRE_CHARGE_REVIEW = 'PRE_CHARGE_REVIEW',
  REJECTED = 'REJECTED'
}

enum PaymentType {
  CHARGE = 'CHARGE',
  DEPOSIT = 'DEPOSIT'
}

type PaymentAttributes = {
  authorisationUrl: string
  error: string
  qrcodeUrl: string
  status: string
}

export type Payment = {
  amount: {
    symbol: string
    value: string
  }
  amountMinor: string
  beneficiaryId: string
  error?: string
  extraAttributes?: PaymentAttributes
  id: string
  insertedAt: string
  state: PaymentState
  type: PaymentType
}
